import { DataBean } from "../DataBean";

export class Exportations extends DataBean {


    public async getExportationsCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("ProcessContractERP", "java.util.List_getExportationsCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }

  public async getExportProcessItemsRender(page:any,Rows:any,props:any): Promise<any> {
        return this.getCustomService("ProcessContractERP", "com.advantage.shared.Report_getExportProcessItemsRender_Number_Number_java.util.Map", [page,Rows,props]);
    }
 
}